import React from 'react';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import { IconDots } from 'design-system/icons/IconDots';
// Web header buttons use the shared icon button, which adds the hover state and
// keeps the icon off the window edge.
const SmartRuleMenuButton = ({ onPress }) => (<NavigationHeaderRightIconButton onPress={onPress}>
    <IconDots colorKey="primary"/>
  </NavigationHeaderRightIconButton>);
export default SmartRuleMenuButton;
